import { pipe, tap } from 'wonka';
import { Exchange, createClient, dedupExchange, cacheExchange, fetchExchange } from 'urql';
import { auth } from './Auth';

export const errorExchange: Exchange = ({ forward }) => {
  return ops$ =>
    pipe(
      forward(ops$),
      tap(({ error }) => {
        // the error is a CombinedError with networkError and graphqlErrors properties
        if (error && error.response) {
          if (error.response.status === 401) {
            auth.login();
          }

          if (error.response.status === 403) {
            window.location.assign(process.env.REACT_APP_PLATFORM_URI);
          }
        }
      })
    );
};

const client = createClient({
  url: `${process.env.REACT_APP_API_URI}/graphql`,
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${auth.getIdToken()}`,
    },
  },
  exchanges: [dedupExchange, cacheExchange, errorExchange, fetchExchange],
});

export default client;
